import { Inject, Pipe, PipeTransform } from '@angular/core';
import { ProductPrice } from '../api/contracts/product';
import { APP_CONFIG, AppConfig } from '../config/app-config';

@Pipe({
  name: 'getPrimaryCurrencyPrice',
})
export class GetPrimaryCurrencyPricePipe implements PipeTransform {
  constructor(@Inject(APP_CONFIG) private readonly appConfig: AppConfig) {}
  transform(priceObj: ProductPrice): number {
    const mainCurrency = this.appConfig.mainCurrency;    
    return priceObj[mainCurrency];
  }
}
